module.exports = __webpack_public_path__ + "img/10x_lg.c4e91dfa.jpg";